import React, { useEffect, useState } from 'react';

import moment from 'moment';
import { Grid, Typography } from '@material-ui/core';
import { AccountBox, AirportShuttle, Assignment, NoteAdd, PeopleAltOutlined, Print, Receipt, ShuffleOutlined, Spellcheck } from '@material-ui/icons';
import { ValidatorForm } from 'react-material-ui-form-validator';

import { useFormNew } from '../../../hooks/useFormNew';
import { useTraslados } from '../../../hooks/useCases/useTraslados';
import { DatosSolicitudTraslado } from '../Stepper/DatosSolicitudTraslado';
import { DocumentacionDiagnosticoTraslado } from '../Stepper/DocumentacionDiagnosticoTraslado';
import { DatosTraslado } from '../Stepper/DatosTraslado';
import { GTab } from '../../atomic/organisms/GenericTab';
import { DatosTitularTraslado } from '../Stepper/DatosTitularTraslado';
import { AdministrarSolicitud } from './AdministrarSolicitud';
import { initTrasladosValues, sendTrasladosValues } from '../data/formTrasladoData';
import { ButtonGeneric } from '../../atomic/atoms/Buttons';
import { NotasTraslados } from './NotasTraslados';
import { GenericModal } from '../../atomic/organisms/GenericModal';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import IconEstado from '../../autorizaciones/UI/IconEstado';

export const ModalAuditarTraslados = ({ estadoActual, handleClose, fieldsDisabled, esConsulta, seguimiento }) => {
    const { data, put, permisos, get } = useTraslados();
    const { formValues, setFormValues, handleInputChange } = useFormNew(initTrasladosValues(data.dim.tipoSolicitudes[0], data.solicitud));
    const estadoAuditoria = data.dim.estados[1].id;
    const estadoAutorizada = data.dim.estados[3].id;
    const estadoRechazada = data.dim.estados[4].id;
    const estadoFinalizada = data.dim.estados[5].id;

    const disabledModal = estadoAuditoria !== estadoActual || fieldsDisabled || !permisos.home.auditoria.administracion;
    const auditoriaMedica = permisos.home.auditoria.auditoriaMedica && estadoActual !== estadoFinalizada;

    useEffect(() => { if (data.solicitud.traslado?.id) get.notasTraslado(data.solicitud.traslado.id) }, [])

    return (
        <GTab
            tabs={[
                {
                    label: "Datos del Titular",
                    icon: <PeopleAltOutlined />,
                    component: (
                        <ValidatorForm onSubmit={() => put.afiliaciones.contactoAfiliado({
                            idAfiliado: formValues.afiliado.id_afiliado,
                            mail: formValues.afiliado.domiciliosAfiliados.mail,
                            telefono: formValues.afiliado.domiciliosAfiliados.telefono,
                            celular: formValues.afiliado.domiciliosAfiliados.celular,
                        }, false, "Datos Contacto Afiliado Guardados Correctamente")}>
                            <SubmitContainer disabled={auditoriaMedica ? false : disabledModal} seguimiento={seguimiento} titularTab>
                                <DatosTitularTraslado
                                    {...{ formValues, setFormValues }}
                                    disabled={esConsulta ? true : (auditoriaMedica ? false : disabledModal)}
                                />
                            </SubmitContainer>
                        </ValidatorForm>
                    )
                },
                {
                    label: "Administrar",
                    icon: <ShuffleOutlined />,
                    component: (
                        <AdministrarSolicitud {...{ estadoActual, handleClose, formValues }} />
                    ),
                    filter: estadoActual === estadoRechazada || estadoActual === estadoFinalizada || fieldsDisabled
                },
                {
                    label: "Datos de la Solicitud",
                    icon: <Receipt />,
                    component: (
                        <ValidatorForm onSubmit={() => put.solicitudModal(sendTrasladosValues(formValues), "Datos Solicitud Guardados Correctamente")}>
                            <SubmitContainer disabled={auditoriaMedica || estadoAutorizada || estadoFinalizada ? false : disabledModal} seguimiento={seguimiento}>
                                <DatosSolicitudTraslado
                                    {...{ formValues, handleInputChange, setFormValues }}
                                    disabled={esConsulta ? true : ((auditoriaMedica || estadoAutorizada || estadoFinalizada) ? false : disabledModal)}
                                />
                            </SubmitContainer>
                        </ValidatorForm>
                    )
                },
                {
                    label: "Diagnostico y Documentación",
                    icon: <Assignment />,
                    component: (
                        <ValidatorForm onSubmit={() => put.solicitudModal(sendTrasladosValues(formValues), "Documentación/Diagnóstico Solicitud Guardados Correctamente")}>
                            <SubmitContainer disabled={auditoriaMedica ? false : disabledModal} seguimiento={seguimiento}>
                                <DocumentacionDiagnosticoTraslado
                                    {...{ formValues, setFormValues }}
                                    disabled={esConsulta ? true : (auditoriaMedica ? false : disabledModal)}
                                />
                            </SubmitContainer>
                        </ValidatorForm>
                    )
                },
                {
                    label: "Datos de Traslado",
                    icon: <AirportShuttle />,
                    component: (
                        <ValidatorForm onSubmit={() => put.solicitudModal(sendTrasladosValues(formValues), "Datos Traslado Guardados Correctamente")}>
                            <SubmitContainer seguimiento={seguimiento}>
                                <DatosTraslado
                                    modal {...{ formValues, setFormValues }}
                                    disabled={esConsulta ? true : (auditoriaMedica ? false : disabledModal)}
                                />
                            </SubmitContainer>
                        </ValidatorForm>
                    )
                },
                {
                    label: "Datos de Carga",
                    icon: <AccountBox />,
                    component: (
                        <Grid container justify='center'>
                            <Grid item xs={12} md={4} flexDirection="column" style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "1em" }}>
                                <Typography variant='h6' style={{ fontSize: "1.2em" }}>Carga Usuario</Typography>
                                <Typography variant='h6' style={{ fontSize: "1em" }}>{formValues?.usuarioAlta?.userName}</Typography>
                            </Grid>
                            <Grid item xs={12} md={4} flexDirection="column" style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "1em" }}>
                                <Typography variant='h6' style={{ fontSize: "1.2em" }}>Fecha de Carga</Typography>
                                <Typography variant='h6' style={{ fontSize: "1em" }}>{moment(formValues.fechaAlta).format("DD/MM/YYYY - hh:mm")}</Typography>
                            </Grid>

                            {(estadoAutorizada === estadoActual || estadoRechazada === estadoActual || estadoFinalizada === estadoActual) && (
                                <Grid item xs={12} flexDirection="column" style={{ display: "flex", justifyContent: "center", marginTop: "1em" }}>
                                    <ButtonGeneric
                                        type="button"
                                        text={'Imprimir'}
                                        startIcon={<Print />}
                                        color="primary"
                                        onClick={() => get.files.pdfSolicitud(formValues.id)}
                                        size={"small"}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    )
                },
                {
                    label: "Notas",
                    icon: <Spellcheck />,
                    component: (
                        <Grid container justify='center' style={{ marginTop: '1.5em' }}>
                            <NotasTraslados
                                {...{ formValues, disabled: esConsulta ? true : (estadoAutorizada === estadoActual || estadoRechazada === estadoActual) }}
                            />
                        </Grid>
                    )
                },
            ]}
        />
    )
}

const SubmitContainer = ({ children, disabled, seguimiento, titularTab }) => {
    const [openModalConsumos, setOpenModalConsumos] = useState(false)
    const { data } = useTraslados();
    console.log(data.solicitud);
    return (
        <>
            <Grid container spacing={1} >
                {
                    titularTab &&
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "center", marginTop: "2em", marginBottom: "2em" }}>
                        <ButtonGeneric
                            color="primary"
                            text="Historial"
                            onClick={() => setOpenModalConsumos(true)}
                            startIcon={<NoteAdd/>}
                        />
                    </Grid>
                }
                <Grid item xs={12}>
                    {children}
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: '1em' }}>
                    <ButtonGeneric
                        type="submit"
                        color="primary"
                        text="Guardar"
                        disabled={disabled || seguimiento}
                    />
                </Grid>
            </Grid>
            <GenericModal
                open={openModalConsumos}
                closeModal={() => setOpenModalConsumos(false)}
                title={'HISTORIAL'}
            >
                <TableGeneric
                    data={data.solicitud.historialConsumos ?? []}
                    align="center"
                    colTitleStyle={{ fontSize: '1.2em' }}
                    withoutPagination
                    rowStyle={{
                        fontWeight: "bold"
                    }}
                    columns={[
                        {
                            label: "Estado",
                            customBody: ({ idEstado }) => {
                                const estado = data.dim.estados.find(({ id }) => id === idEstado)
                                return (
                                    <IconEstado
                                        useColorTable
                                        texto={estado.letra}
                                        backgroundColor={estado.color}
                                        descripcion={estado.descripcion}
                                    />
                                )
                            }
                        },
                        {
                            label: "Fecha Alta",
                            customBody: ({ fechaAlta }) => moment(fechaAlta).format("DD/MM/YYYY")
                        },
                        {
                            id: "id",
                            label: "N° Orden",
                            sort: true
                        },
                        {
                            label: "Práctica",
                            customBody: ({ practica }) => practica ? `${practica?.codNom} - ${practica?.desNom}` : ""
                        },
                        {
                            label: "Diagnostico",
                            customBody: ({ diagnostico }) => diagnostico?.problema || "No asignado"
                        },
                        {
                            label: "Efector",
                            customBody: ({ efector }) => efector?.razonSocial ? efector?.razonSocial.trim() : ""
                        }
                    ]}
                />
            </GenericModal >
        </>
    )
}